
  export default {
    computed: {
      coverType () {
        return this.$store.getters['products/getCoverType'];
      },
      plan () {
        return this.$store.getters['products/get'];
      },
      search () {
        return this.$store.getters['search/get'];
      }
    }
  };
